export default "__VITE_ASSET__DcLs9p1$__"